import { type ISoftDelete } from './firebase/firestore/model';

export interface IAttachment
  extends ISoftDelete,
    Pick<File, 'name' | 'type' | 'size' | 'lastModified'> {
  path: string;
  link: string;
}
